import { useCustomer } from '@/hooks/useCustomer';

export const getUserId = (): string => {
  // if we have a customer id, return it
  const customer = useCustomer.getState()?.customer;

  if (customer?.id) {
    return customer.id.replace('gid://shopify/Customer/', '').toString();
  }

  return undefined;
};
